import { render, staticRenderFns } from "./not-match-form.vue?vue&type=template&id=43d02d5b&"
import script from "./not-match-form.vue?vue&type=script&lang=js&"
export * from "./not-match-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports